import { Action } from '@ngrx/store';

export enum ConversationActionType {
    LOAD_CONVERSATION = '[Messenger/Conversation] LOAD_CONVERSATION',
    LOAD_CONVERSATION_FAILED = '[Messenger/Conversation] LOAD_CONVERSATION_FAILED',
    LOAD_CONVERSATION_SUCCEEDED = '[Messenger/Conversation] LOAD_CONVERSATION_SUCCEEDED',
    SEND_MESSAGE = '[Messenger/Conversation] SEND_MESSAGE',
    SEND_MESSAGE_FAILED = '[Messenger/Conversation] SEND_MESSAGE_FAILED',
    SEND_MESSAGE_SUCCEEDED = '[Messenger/Conversation] SEND_MESSAGE_SUCCEEDED',
    LOAD_MESSAGES = '[Messenger/Conversation] LOAD_MESSAGES',
    LOAD_MESSAGES_FAILED = '[Messenger/Conversation] LOAD_MESSAGES_FAILED',
    LOAD_MESSAGES_SUCCEEDED = '[Messenger/Conversation] LOAD_MESSAGES_SUCCEEDED',
    ENTERED_CONVERSATION = '[Messenger/Conversation] ENTERED_CONVERSATION',
    LEFT_CONVERSATION = '[Messenger/Conversation] LEFT_CONVERSATION',
}


export class LoadConversationAction implements Action {
    readonly type = ConversationActionType.LOAD_CONVERSATION;
    constructor(public conversationID: string) {}
}

export class LoadConversationFailedAction implements Action {
    readonly type = ConversationActionType.LOAD_CONVERSATION_FAILED;
    constructor(public error: any) {}
}

export class LoadConversationSucceededAction implements Action {
    readonly type = ConversationActionType.LOAD_CONVERSATION_SUCCEEDED;
    constructor(public conversation: any) {}
}

export class SendMessageAction implements Action {
    readonly type = ConversationActionType.SEND_MESSAGE;
    constructor(public conversationID: string, public message: string) {}
}

export class SendMessageFailedAction implements Action {
    readonly type = ConversationActionType.SEND_MESSAGE_FAILED;
    constructor(public error: any) {}
}

export class SendMessageSucceededAction implements Action {
    readonly type = ConversationActionType.SEND_MESSAGE_SUCCEEDED;
    constructor() {}
}

export class LoadMessagesAction implements Action {
    readonly type = ConversationActionType.LOAD_MESSAGES;
    constructor(public conversationID: string) {}
}

export class LoadMessagesFailedAction implements Action {
    readonly type = ConversationActionType.LOAD_MESSAGES_FAILED;
    constructor(public error: any) {}
}

export class LoadMessagesSucceededAction implements Action {
    readonly type = ConversationActionType.LOAD_MESSAGES_SUCCEEDED;
    constructor(public messages: any) {}
}

export class EnteredConversationAction implements Action {
    readonly type = ConversationActionType.ENTERED_CONVERSATION;
    constructor(public conversationID: string) {}
}

export class LeftConversationAction implements Action {
    readonly type = ConversationActionType.LEFT_CONVERSATION;
    constructor(public conversationID: string) {}
}

export type ConversationAction
    = LoadConversationAction
    | LoadConversationFailedAction
    | LoadConversationSucceededAction
    | SendMessageAction
    | SendMessageFailedAction
    | SendMessageSucceededAction
    | LoadMessagesAction
    | LoadMessagesFailedAction
    | LoadMessagesSucceededAction
    | EnteredConversationAction
    | LeftConversationAction;
